import { FC } from 'react';
import { DragDropContext, Draggable, Droppable, OnDragEndResponder } from 'react-beautiful-dnd';
import { Box, Button, IconCross, Typography, Wrapper } from '@screentone/core';

import { MobileIssueDtoArtifactFragment, MobileIssueSectionContainer } from 'data/generated/graphql';
import styles from './IssueSectionList.module.scss';
import { AddSectionButton } from '../add-section-button/AddSectionButton';

type IssueSectionsListProps = {
  issue: MobileIssueDtoArtifactFragment | null;
  onDragEnd: OnDragEndResponder;
  onDeleteSection: (index: number) => void;
  onInsertSection: (args: { sectionIndex: number; sectionData: MobileIssueSectionContainer }) => void;
};

export const IssueSectionsList: FC<IssueSectionsListProps> = ({
  issue,
  onDragEnd,
  onDeleteSection,
  onInsertSection
}) => {
  if (!issue) return null;

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="mobile-issue-sections">
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps}>
            {issue.root.collection.length === 0 && (
              <AddSectionButton
                sectionIndex={0}
                nextSectionIndex={0}
                onAddSectionFromCollection={onInsertSection}
                issue={issue}
              />
            )}
            {issue.root.collection.map((section, index) => {
              const {
                allessehId,
                attributes: { sectionLabel }
              } = section;
              const key = allessehId ?? '';
              return (
                <Draggable key={key} draggableId={key} index={index}>
                  {(dragProvided) => (
                    <div
                      ref={dragProvided.innerRef}
                      {...dragProvided.draggableProps}
                      {...dragProvided.dragHandleProps}
                      style={{
                        ...dragProvided.draggableProps.style
                      }}
                    >
                      <Wrapper padding={{ all: 'sm' }}>
                        <Box>
                          <Box.Content className={styles.issueSectionItem} padding={{ all: 'sm' }}>
                            <div>
                              <Typography weight="bold">{sectionLabel}</Typography>
                              <Typography size="sm" color="asphalt">
                                {allessehId}
                              </Typography>
                            </div>
                            <div>
                              <Button tertiary color="lava" icon={IconCross} onClick={() => onDeleteSection(index)} />
                            </div>
                          </Box.Content>
                        </Box>
                      </Wrapper>

                      <AddSectionButton
                        sectionIndex={index}
                        nextSectionIndex={index + 1}
                        onAddSectionFromCollection={onInsertSection}
                        issue={issue}
                      />
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
